import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

const lookup = (obj, key) => key.split(".").reduce((o, k) => (o && o[k] !== undefined ? o[k] : undefined), obj);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("vbs_lang") || "en");

  useEffect(() => {
    localStorage.setItem("vbs_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => lookup(translations[lang], key) ?? lookup(translations.en, key) ?? key;

  return <LanguageContext.Provider value={{ lang, setLang, t }}>{children}</LanguageContext.Provider>;
}

export const useLang = () => useContext(LanguageContext);
